import { Modal } from "antd";
import { createElement } from "react";

// The dashboard's confirm dialogs, extracted from DashboardAltPage so the toolbar
// and grid stay declarative.

export function confirmDeleteWidget(onOk: () => void) {
  Modal.confirm({
    title: "Delete Widget",
    content: "Are you sure you want to remove this widget?",
    okText: "Delete",
    okType: "danger",
    cancelText: "Cancel",
    onOk,
  });
}

export function confirmDuplicateDashboard(name: string, onOk: () => void) {
  Modal.confirm({
    title: "Duplicate Dashboard",
    content: `Create a copy of "${name}"?`,
    okText: "Duplicate",
    cancelText: "Cancel",
    onOk,
  });
}
export function confirmDeleteDashboard(name: string, onOk: () => void) {
  Modal.confirm({
    title: "Delete Dashboard",
    content: `Are you sure you want to delete "${name}"? This cannot be undone.`,
    okText: "Delete",
    okType: "danger",
    cancelText: "Cancel",
    onOk,
  });
}

/** Renders a bounded list of governed widget titles for the two refusal dialogs below. */
function widgetList(titles: string[]) {
  const shown = titles.slice(0, 8);
  const extra = titles.length - shown.length;
  return createElement(
    "ul",
    { style: { margin: "8px 0 0", paddingLeft: 18 } },
    ...shown.map((title, i) => createElement("li", { key: i }, title)),
    extra > 0 ? createElement("li", { key: "more" }, `and ${extra} more`) : null,
  );
}

/**
 * Refuse a Slicer deletion while widgets still follow it, through a binding or a
 * `{Slicer.KEY.Variable}` token. Deleting must never silently change another widget's
 * behavior, so unbinding stays an explicit per-widget act.
 */
export function refuseControllerDelete(widgetTitles: string[]) {
  const count = widgetTitles.length;
  Modal.info({
    title: "Widgets follow this slicer",
    content: createElement(
      "span",
      null,
      `${count} widget${count !== 1 ? "s" : ""} follow this slicer. Remove their bindings or tokens first, then delete it.`,
      widgetList(widgetTitles),
    ),
    okText: "Got it",
  });
}

/** Refuse removal of a picker while widgets bind that section — it would strand them. */
export function confirmControlsNarrowingBlocked(pickerLabel: string, widgetTitles: string[]) {
  const count = widgetTitles.length;
  Modal.info({
    title: `Cannot remove the ${pickerLabel.toLowerCase()}`,
    content: createElement(
      "span",
      null,
      `${count} widget${count !== 1 ? "s" : ""} follow this slicer for that filter. Remove their bindings first.`,
      widgetList(widgetTitles),
    ),
    okText: "Got it",
  });
}
